<template>
  <section>
    <div class="row">
      <!-- <div class="col-lg-4 d-none .d-md-none d-lg-block align-self-center">
        <div style="float:right;text-align: right;" class="col-8">
          <div class="row align-items-center">
            <span style="display:inline-block;vertical-align: middle; padding:5px">Follow Us On:</span>
            <a href="https://www.facebook.com/amcredits" target="_blank">
              <img
                style="display:inline-block;vertical-align: middle;"
                src="../../assets/imgs/smallIcon1.png"
                alt
              />
            </a>
            <a href="https://www.twitter.com/amcredit_com" target="_blank">
              <img
                style="display:inline-block;vertical-align: middle;"
                src="../../assets/imgs/smallIcon2.png"
                alt
              />
            </a>
            <a href="https://americancredit.business.site/" target="_blank">
              <img
                style="display:inline-block;vertical-align: middle;"
                src="../../assets/imgs/smallIcon3.png"
                alt
              />
            </a>
            <a href="https://www.linkedin.com/company/amcredit" target="_blank">
              <img
                style="display:inline-block;vertical-align: middle;"
                src="../../assets/imgs/smallIcon4.png"
                alt
              />
            </a>
          </div>
        </div>
      </div> -->
      <div class="offset-lg-2 col-lg-8 col-sm-12">
        <div class="step-form__main pt-3">
          <div class="row">
            <div class="col-lg-3 col-sm-12">
              <span>Business Information</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span class="step-text-active">Personal Information</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span v-if="frontAppliedProductId == 10000057823975">Equipment Details</span>
              <span v-else>Financial Review</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span>
                <a href="tel:855-904-0188">
                  <i aria-hidden="true" class="phone-icon fa fa-phone"></i>
                  855-904-0188 
                </a>
              </span>
            </div>
          </div>
          <hr />
          <el-row :gutter="0">
            <el-col :span="16">
              <el-form class="step-form__form" :model="step2Form" :rules="rules" ref="step2Form">
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item label="Title" prop="title" class="step-form__form-item--with-unit" required>
                      <el-select
                        v-model="step2Form.title"
                        placeholder="Please select title"
                        :disabled="isEditable === 1"
                      >
                        <el-option
                          v-for="item in titleData"
                          :key="item.value"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!--First Name-->
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item label="First name" prop="firstName" required>
                      <el-input type="text" placeholder="First name" :maxlength="30" v-model="step2Form.firstName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item label="Middle name">
                      <el-input type="text" placeholder="Middle name" :maxlength="30" v-model="step2Form.middleName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item label="Last name" prop="lastName" required>
                      <el-input type="text" placeholder="Last name" :maxlength="30" v-model="step2Form.lastName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="Street address" prop="streetAddress" required>
                  <el-input
                    type="text"
                    placeholder
                    :maxlength="40"
                    v-model="step2Form.streetAddress"
                  ></el-input>
                </el-form-item>

                <!-- <el-form-item label="Street Address 2">
                  <el-input
                    type="tel"
                    placeholder
                    :maxlength="40"
                    v-model="step2Form.streetAddress2"
                  ></el-input>
                </el-form-item> -->
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="City name" prop="cityName" required>
                      <el-input type="text" placeholder :maxlength="30" v-model="step2Form.cityName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="State" prop="state" class="step-form__form-item--with-unit" required>
                      <el-select v-model="step2Form.state" placeholder="Please Select State">
                        <el-option
                          v-for="item in stateS"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="Zip code" prop="zipCode" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Please enter a 5-digit postal code"
                        :maxlength="5"
                        v-model="step2Form.zipCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      label="Date start living at current address"
                      prop="month"
                      required
                    >
                      <el-date-picker
                        v-model="step2Form.month"
                        placeholder="YYYY-MM-DD"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions1"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      label="Monthly housing payment"
                      prop="housingCost"
                      required
                    >
                      <el-input
                        type="number"
                        placeholder="What is your monthly rent or mortgage payment? (Please input numbers only)"
                        v-model="step2Form.housingCost" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        :maxlength="8"
                        :min="0">
							        </el-input>
                      <!-- If you live with others, only include the portion of the monthly housing payment you are responsible for. -->
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="Home ownership(select)" prop="homeOwnership" required>
                      <el-radio-group v-model="step2Form.homeOwnership">
                        <el-radio label="Rent">Rent</el-radio>
                        <el-radio label="Mortgage">Mortgage</el-radio>
                        <el-radio label="Fully Own">Fully Own</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="Date of birth" prop="dateOfBirth" required>
                      <el-date-picker
                        v-model="step2Form.dateOfBirth"
                        type="date"
                        placeholder="Please select date of birth"
                        @change="getData"
                        :picker-options="pickerOptions1"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      label="Marital Status"
                      prop="status"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="step2Form.status" placeholder="Please select marital status">
                        <el-option
                          v-for="item in mastateS"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      label="Business ownership %"
                      prop="businessOwnership"
                      required
                    >
                      <el-input-number :min="0" :max="100" v-model="step2Form.businessOwnership"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="SSN" prop="ssn">
                      <el-input
                        type="text"
                        placeholder="Please input your SSN."
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        v-model="step2Form.ssn"
                        :maxlength="9"
                      ></el-input>
                      <!-- We use 256-bit SSL protection and strict, high levels of security
                      <br />and encryption standards to keep
                      your information safe. -->
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Driver license" prop="driverLicense">
                      <el-input
                        type="text"
                        placeholder
                        :maxlength="20"
                        v-model="step2Form.driverLicense"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Cell phone" prop="cellphone" ref="cellphone" required>
                      <el-input
                        type="tel"
                        placeholder="Mobile phone"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        v-model="step2Form.cellPhone"
                        :maxlength="10"
                        @change="allowSendingVerifyCode"
                        @blur="inputBlurFn('cellphone')"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Click to get verifiction code" prop="SMSVerificationCode" required>
                      <el-input
                        type="number"
                        placeholder="Verifiction code"
                        v-model="step2Form.validCode"
                        :disabled="isDisabledSendingVerifyCode"
                        :maxlength="6"
                        @blur="inputBlurFn('SMSVerificationCode')"
                      ></el-input>
                      <el-button
                        type="primary"
                        size="mini"
                        class="user-operation__sms-button lightbluebg"
                        style="margin-right:5px;margin-top:2px;"
                        :loading="isLoading"
                        :disabled="SMSVerificationCodeBtn.disabled"
                        @click="getSMSVerificationCode"
                      >{{SMSVerificationCodeBtn.text}}</el-button>
                    </el-form-item>
                  </el-col> -->
                </el-row>

                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px;" v-on:click="showAddOwner = !showAddOwner">Additional Principals/ Officers/ Guarantors (if any)<i style="float: right; margin-right: 10px;" class="fa" :class="{'fa-chevron-up': showAddOwner, 'fa-chevron-down': !showAddOwner }" aria-hidden="true"></i></h3>
                </el-row>

                <div v-show="showAddOwner">

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item label="Title" prop="title2" class="step-form__form-item--with-unit">
                        <el-select
                          v-model="step2Form.title2"
                          placeholder="Please select title"
                          :disabled="isEditable === 1"
                        >
                          <el-option
                            v-for="item in titleData"
                            :key="item.value"
                            :label="item.text"
                            :value="item.text"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!--First Name-->
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item label="First name" prop="firstName2">
                        <el-input type="text" placeholder="First name" :maxlength="30" v-model="step2Form.firstName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item label="Middle name">
                        <el-input type="text" placeholder="Middle name" :maxlength="30" v-model="step2Form.middleName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item label="Last name" prop="lastName2">
                        <el-input type="text" placeholder="Last name" :maxlength="30" v-model="step2Form.lastName2"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="Street address" prop="streetAddress2">
                    <el-input
                      type="text"
                      placeholder
                      :maxlength="40"
                      v-model="step2Form.streetAddress2"
                    ></el-input>
                  </el-form-item>

                  <!-- <el-form-item label="Street Address 2">
                    <el-input
                      type="tel"
                      placeholder
                      :maxlength="40"
                      v-model="step2Form.streetAddress2"
                    ></el-input>
                  </el-form-item> -->
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="City name" prop="cityName2">
                        <el-input type="text" placeholder="City Name" :maxlength="30" v-model="step2Form.cityName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="State" prop="state2" class="step-form__form-item--with-unit">
                        <el-select v-model="step2Form.state2" placeholder="Please Select State">
                          <el-option
                            v-for="item in stateS"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Zip code" prop="zipCode2">
                        <el-input
                          type="text"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          placeholder="Please enter a 5-digit postal code"
                          :maxlength="5"
                          v-model="step2Form.zipCode2"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item
                        label="Date start living at current address"
                        prop="month2"
                      >
                        <el-date-picker
                          v-model="step2Form.month2"
                          placeholder="YYYY-MM-DD"
                          format="yyyy-MM-dd"
                          :picker-options="pickerOptions1"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item
                        label="Monthly housing payment"
                        prop="housingCost2"
                      >
                        <el-input
                          type="number"
                          placeholder="What is your monthly rent or mortgage payment? (Please input numbers only)"
                          v-model="step2Form.housingCost2"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0">
                        </el-input>
                        <!-- If you live with others, only include the portion of the monthly housing payment you are responsible for. -->
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Home ownership(select)" prop="homeOwnership2">
                        <el-radio-group v-model="step2Form.homeOwnership2">
                          <el-radio label="Rent">Rent</el-radio>
                          <el-radio label="Mortgage">Mortgage</el-radio>
                          <el-radio label="Fully Own">Fully Own</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Date of birth" prop="dateOfBirth2">
                        <el-date-picker
                          v-model="step2Form.dateOfBirth2"
                          type="date"
                          placeholder="Please select date of birth"
                          @change="getData2"
                          :picker-options="pickerOptions1"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item
                        label="Marital status"
                        prop="status2"
                        class="step-form__form-item--with-unit"
                      >
                        <el-select v-model="step2Form.status2" placeholder="Please select marital status">
                          <el-option
                            v-for="item in mastateS"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item
                        label="Business ownership %"
                        prop="businessOwnership2"
                      >
                        <el-input-number :min="0" :max="100 - step2Form.businessOwnership" v-model="step2Form.businessOwnership2"></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="SSN" prop="ssn2">
                        <el-input
                          type="text"
                          placeholder="Please input your SSN."
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          v-model="step2Form.ssn2"
                          :maxlength="9"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Driver license" prop="driverLicense2">
                        <el-input
                          type="text"
                          placeholder
                          :maxlength="20"
                          v-model="step2Form.driverLicense2"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Email" prop="email2">
                        <el-input
                          type="text"
                          placeholder="Email address"
                          v-model="step2Form.email2"
                          :maxlength="30"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Cell phone" prop="cellphone2">
                        <el-input
                          type="tel"
                          placeholder="Mobile phone"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          v-model="step2Form.cellPhone2"
                          :maxlength="10"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <hr>

                <h4 style="text-align: left; font-size: 20px;">Please verify primary owner's cell phone number: <span style="color: #006499;">{{step2Form.cellPhone}}</span></h4>

                <el-row :gutter="20">
                  <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Cell phone" prop="cellphone" ref="cellphone" required>
                      <el-input
                        type="tel"
                        placeholder="Mobile phone"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        v-model="step2Form.cellPhone"
                        :maxlength="10"
                        @change="allowSendingVerifyCode"
                        @blur="inputBlurFn('cellphone')"
                      ></el-input>
                    </el-form-item>
                  </el-col> -->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Click to get verifiction code" prop="SMSVerificationCode" required>
                      <el-input
                        type="number"
                        placeholder="Verifiction code"
                        v-model="step2Form.validCode"
                        :disabled="isDisabledSendingVerifyCode"
                        :maxlength="6"
                        @blur="inputBlurFn('SMSVerificationCode')"
                      ></el-input>
                      <el-button
                        type="primary"
                        size="mini"
                        class="user-operation__sms-button lightbluebg"
                        style="margin-right:5px;margin-top:2px;"
                        :loading="isLoading"
                        :disabled="SMSVerificationCodeBtn.disabled"
                        @click="getSMSVerificationCode"
                      >{{SMSVerificationCodeBtn.text}}</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
          <div class="step-form__btn-container">
            <!--<button class="step-form__btn-prev" @click="goBack">Back step</button>-->
            <!--<button class="step-form__btn-next" @click="submitForm">Next step</button>-->
            <el-button
              type="primary"
              class="rounded-pill bluebg px-5"
              style="float: left;"
              @click="goBack"
            >Prev</el-button>

            <el-button
              type="primary"
              :loading="isLoading"
              class="rounded-pill bluebg px-5"
              style="float: right;"
              @click="submitForm"
            >Next</el-button>
          </div>
		  <br/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../../vuex/types";
import _ from "lodash";
import api from "../../vuex/api/index";
import axios from 'axios';

// ä¼�ä¸šé‚£è¾¹å¦‚æžœç•Œé�¢å·®å¼‚å�˜å¤§ï¼Œåˆ™å»ºè®®åˆ†å‡ºåŽ»å�¦ä¸€ä¸ªç»„ä»¶
export default {
  data() {
    const assignValidator = (type, trigger = "blur") =>
      Object.assign(
        {
          //        required: true,
          trigger
        },
        {
          validator: (rules, value, callback, source, options) => {
            this.$store.dispatch(type, {
              rules,
              value,
              callback,
              source,
              options
            });
          }
        }
      );
    return {
      frontAppliedProductId: localStorage.getItem('$appliedProductId'),
      pickerOptions1: {
        disabledDate(time) {
          let curDate = (new Date()).getTime();
          let I8Years = (365 * 18 + 5) * 24 * 3600 * 1000;
          let I00Years = (365 * 100 + 26) * 24 * 3600 * 1000;
          let I8YearsDate = curDate - I8Years;
          let I00YearsDate = curDate - I00Years;
          // return time.getTime() > I8YearsDate || time.getTime() < I00YearsDate;
          return time.getTime() < I00YearsDate;
        }
      },
      pickerOptions2: {},
      dateOfBirthDis: false,
      isLoading: false,
      isLoadingCode: false,
      isSubmitting: false,
      isEditable: "",
      showAddOwner: false,
      //				screenHeight: document.body.clientHeight,
      isDisabledSendingVerifyCode: true,
      SMSVerificationCode: "",
      isApplyFirst: true,
      SMSVerificationCodeBtn: {
        disabled: true,
        text: "Get Code"
      },
      rules: {
        title: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Select a title for you."));
              } else {
                callback();
              }
            }
          }
        ],
        firstName: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Enter a first name."));
              } else {
                callback();
              }
            }
          }
        ],
        middleName: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Enter a middle name."));
              } else {
                callback();
              }
            }
          }
        ],
        lastName: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Enter a Last name."));
              } else {
                callback();
              }
            }
          }
        ],
        validCode: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Please enter a valid code."));
              } else {
                callback();
              }
            }
          }
        ],
        streetAddress: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Street Address 1 can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],

        cityName: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("City Name can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        city: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("City can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        personDocumentType: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("PersonDocumentType can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        zipCode: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Zip code can not be empty"));
              } else if (_.trim(value).length != 5 ) {
                callback(new Error("Zip code must be 5 digital"));
              }
              else if (!/^[0-9]*$/.test(value)) {
                callback(new Error("Input error"));
              } else {
                callback();
              }
            }
          }
        ],
        state: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("State can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        month: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Date of you start to live can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        dateOfBirth: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Date of Birth can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        status: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Marital Status can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],

        ssn: [
          {
            // require: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (_.trim(value) === "") {
                // callback(new Error("SSN can not be empty"));
                callback();
              } else if (!/^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/.test(value)) {
                callback(new Error("Please input a valid SSN"));
              } else {
                callback();
              }
            }
          }
        ],
        driverLicense: [
          // {
          //   require: true,
          //   trigger: "blur",
          //   validator: (rule, value, callback) => {
          //     if (_.trim(value) === "") {
          //       callback(new Error("Driver License can not be empty"));
          //     } else {
          //       callback();
          //     }
          //   }
          // }
        ],

        housingCost: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Monthly home payment can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],

        homeOwnership: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Home Ownership can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        cellphone: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Phone can not be empty"));
              }else if (_.trim(value).length != 10 ) {
                callback(new Error("Phone must be 10 digital"));
              } 
              else {
                callback();
              }
            }
          }
        ],
        SMSVerificationCode: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("Verification code can not be empty"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      stateS: [],
      titleData: [],
      citizenshipS: [],
      mastateS: [],
      isEditable: 0,
      dateOfBirthStr: "",
      dateOfBirth2Str: "",
      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        cellPhone: "",
        validCode: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        dateOfBirth: "",
        homeOwnership: "",
        military: false,
        ssn: "",
        driverLicense: "",
        month: "",
        housingCost: "",
        businessOwnership: "",
        firstName2: "",
        middleName2: "",
        lastName2: "",
        email2: "",
        cellPhone2: "",
        streetAddress2: "",
        cityName2: "",
        title2: "",
        zipCode2: "",
        state2: "",
        dateOfBirth2: "",
        homeOwnership2: "",
        month2: "",
        housingCost2: "",
        ssn2: "",
        status2: "",
        driverLicense2: "",
        businessOwnership2: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      //       myInfo: types.GET_MY_INFO,
      userInfo: types.GET_USER
    })
  },
  methods: {
    ...mapActions({
      updatePassword: types.UPDATE_PASSWORD,
      //        getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    allowSendEmailCode() {
      if (this.step2Form.email != "") {
        this.SMSVerificationCodeBtn.disabled = false;
      } else {
        this.SMSVerificationCodeBtn.disabled = true;
      }
    },
    allowSendingVerifyCode(val) {
      if (this.step2Form.cellPhone.length == 10) {
        (this.step2Form.isDisabledSendingVerifyCode = false),
          (this.SMSVerificationCodeBtn = {
            disabled: false,
            text: "Get code"
          });
      }
    },
    getSMSVerificationCode() {
      this.isLoading = true;
      {
        api
          .getSMSVerificationCode({
            mobile: "+1" + this.step2Form.cellPhone,
            isForRegister: false
          })
          .then(res => {
            this.isDisabledSendingVerifyCode = false;
            const resData = res.data;
            let countDownTime = 420;
            if (Number(resData.code) === 0) {
              this.countDown = setInterval(() => {
                this.isLoading = false;
                this.isCounting = true;
                countDownTime -= 1;
                if (countDownTime !== 0) {
                  this.SMSVerificationCodeBtn = {
                    disabled: true,
                    text: `After ${countDownTime} seconds`
                  };
                } else {
                  this.SMSVerificationCodeBtn = {
                    disabled: false,
                    text: "get verification code"
                  };
                  clearInterval(this.countDown);
                  this.isCounting = false;
                }
              }, 1000);
            } else {
              this.isLoading = false;
              this.setAlertMessage({
                show: true,
                content: resData.msg
              });
            }
          })
          .catch(error => {
            if (error) {
              this.isLoading = false;
            } else {
              this.isLoading = false;
            }
          });
      }
    },

    getData(val) {
      this.dateOfBirthStr = val;
      console.log('this.dateOfBirthStr', this.dateOfBirthStr);
      console.log('token', this.userInfo.token);
    },
    getData2(val) {
      this.dateOfBirth2Str = val;
    },
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age > 18;
    },
    getMgxyGetPersonDetails() {
      //èŽ·å�–è¿›ä»¶ä¸ªäººä¿¡æ�¯
      var _this = this;
      //console.warn(this.userInfo)
      api
        .mgxyGetPersonDetails({
          token: _this.userInfo.token,
          frontApply: localStorage.getItem("$applyId"),
          customerId: _this.userInfo.crmCustomerId
        })
        .then(res => {
          var _data = res.data;
          if (_data.code == 0) {
            console.log(_data);
            _this.step2Form.title = _data.result.title;
            _this.step2Form.firstName = _data.result.firstName;
            _this.step2Form.middleName = _data.result.middleName;
            _this.step2Form.lastName = _data.result.lastName;
            _this.step2Form.email = _data.result.email;
            _this.step2Form.dateOfBirth = _data.result.dateOfBirth;
            if (_data.result.dataOfBirth && _data.result.dataOfBirth != "") {
              this.dateOfBirthDis = true;
            }
            _this.step2Form.ssn = _data.result.ssn;
            _this.step2Form.streetAddress = _data.result.streetAddress;
            if (_data.result.streetAddress2) {
              _this.step2Form.streetAddress2 = _data.result.streetAddress2;
            }
            _this.step2Form.driverLicense = _data.result.driverLicense;

            //_this.isApplyFirst = _data.result.isApplyFirst;  // æ²¡æœ‰æŽ¥å�£åˆ¤æ–­æ˜¯å�¦äºŒæ¬¡è¿›ä»¶~~

            //é€šè¿‡isApplyFirstï¼Œåˆ¤æ–­æ˜¯å�¦æ˜¯äºŒæ¬¡è¿›ä»¶
            if (_data.result.email && _data.result.email != "") {
              // yes  é‚®ç®±ä¸ºç©ºï¼Œåˆ™ç¬¬ä¸€æ¬¡è¿›ä»¶
              _this.isEditable = 1;
              _this.isApplyFirst = false;
              _this.step2Form.citizenship = _data.result.personDocumentType; // å¯¹åº”ç•Œé�¢  Citizenship

              _this.step2Form.status = _data.result.status; //å©šå§»çŠ¶æ€� vuale

              _this.step2Form.state = _data.result.state; // å¯¹å¼ˆ ç•Œé�¢ State   å·ž
              _this.step2Form.cityName = _data.result.cityName; // å¯¹åº” ç•Œé�¢ City Name
              _this.step2Form.zipCode = _data.result.zipCode;

              _this.SMSVerificationCodeBtn.disabled = false;
            } else {
              _this.isEditable = 0;
              _this.isApplyFirst = true;
            }
          }
        });
    },
    formatData(data) {
      var arr = [];
      for (var key in data) {
        var obj = {};
        obj.value = data[key];
        obj.text = key;
        arr.push(obj);
      }
      return arr;
    },
    formatDataForSort(data) {
      var arr = [];
      var arr2 = [];
      for (var key in data) {
        arr[arr.length] = data[key];
      }
      arr.sort();
      for (var k in arr) {
        for (key in data) {
          if (data[key] == arr[k]) {
            var obj = {};
            obj.value = data[key];
            obj.text = key;
            arr2.push(obj);
          }
        }
      }
      return arr2;
    },
    getMgxyDictionary() {
      var _this = this;
      api.mgxyDictionary().then(res => {
        _this.stateS = _this.formatData(res.data.result[0]);
        _this.titleData = _this.formatData(res.data.result[7]);
        _this.citizenshipS = _this.formatDataForSort(res.data.result[8]);
        _this.mastateS = _this.formatData(res.data.result[6]);
        var mgxy_income_source = _this.formatData(res.data.result[2]);

        //          _this.getMgxyGetPersonDetails();
      });
    },
    goBack() {
      this.saveApplyLoanProgress({
        router: this.$router,
        token: this.userInfo.token,
        id: this.$route.query.applyLoanId,
        step: 1
      }).then(res => {
        const resData = res.data;
        if (Number(resData.code) === 0) {
          //            if (`${this.$route.query.isEdit}` === 'true') {
          this.$router.push({
            path: `/applyLoan/${this.$route.params.id}/sbl01`,
            query: {
              applyLoanId: this.$route.query.applyLoanId,
              isEdit: true
            }
          });
          //            } else {
          //              this.$router.go(-1)
          //            }
        }
      });
    },

    submitForm() {
      var _this = this;
      this.$refs.step2Form.validate(valid => {
        if (valid) {
          if (!this.getAge(this.dateOfBirthStr)) {
            //æœªå¹´æ»¡18å²�
            this.$alert("Age must be more than 18 years old");
            return;
          }
          this.isLoading = true;
          var isValid = "";
          if (_this.isApplyFirst) {
            //isValid=1 éœ€è¦�éªŒè¯�éªŒè¯�ç �ã€‚isValid=2ä¸�ç”¨éªŒè¯�
            isValid = 2;
          } else {
            _this.SMSVerificationCode = "111111";
            isValid = 2;
          }

          var Month = new Array();
          Month[0] = "January";
          Month[1] = "February";
          Month[2] = "March";
          Month[3] = "April";
          Month[4] = "May";
          Month[5] = "June";
          Month[6] = "July";
          Month[7] = "August";
          Month[8] = "September";
          Month[9] = "October";
          Month[10] = "November";
          Month[11] = "December";

          var postData = {
            tokenId: _this.userInfo.token,
            frontApplyId: _this.userInfo.crmCustomerId,
            lastName: _this.step2Form.lastName,
            firstName: _this.step2Form.firstName,
            middleName: _this.step2Form.middleName,
            email: _this.step2Form.email,
            phone: _this.step2Form.cellPhone,
            validCode: _this.step2Form.validCode,
            streetAddress: _this.step2Form.streetAddress,
            cityName: _this.step2Form.cityName,
            title: _this.step2Form.title,
            state: _this.step2Form.state, // å·ž
            //              personDocumentType: _this.step2Form.citizenship,
            ssn: _this.step2Form.ssn,
            driverLicense: _this.step2Form.driverLicense,
            zipCode: _this.step2Form.zipCode,
            status: _this.step2Form.status, //å©šå§»çŠ¶æ€�
            dateOfBirth: _this.dateOfBirthStr,
            isValid: 1,
            homeOwnership: _this.step2Form.homeOwnership,
            customer_area: _this.step2Form.military ? "Military" : "",
            military: _this.step2Form.military,
            month: _this.step2Form.month.toISOString(),
            housingCost: _this.step2Form.housingCost,
            businessOwnership: _this.step2Form.businessOwnership,
            lastName2: _this.step2Form.lastName2,
            firstName2: _this.step2Form.firstName2,
            middleName2: _this.step2Form.middleName2,
            email2: _this.step2Form.email2,
            phone2: _this.step2Form.cellPhone2,
            streetAddress2: _this.step2Form.streetAddress2,
            cityName2: _this.step2Form.cityName2,
            title2: _this.step2Form.title2,
            state2: _this.step2Form.state2, // å·ž
            ssn2: _this.step2Form.ssn2,
            driverLicense2: _this.step2Form.driverLicense2,
            zipCode2: _this.step2Form.zipCode2,
            status2: _this.step2Form.status2, //å©šå§»çŠ¶æ€�
            dateOfBirth2: _this.dateOfBirth2Str,
            homeOwnership2: _this.step2Form.homeOwnership2,
            month2: _this.step2Form.month2 == "" ? "" : _this.step2Form.month2.toISOString(),
            housingCost2: _this.step2Form.housingCost2,
            businessOwnership2: _this.step2Form.businessOwnership2
          };

          console.log('postData', postData);

          api
            .postForm(
              "/mobile/item/loanItemFrontApply/mgxyUpdateApplyForPersonDetails.ht",
              postData 
            )
            .then(res => {
              console.log(res);
              var _data = res.data;
              this.isLoading = false;
              if (_data.code == 0) {
                // hubspot update contact
                // POST request using axios with set headers
                const body = { 
                  email: _this.customerEmail,
                  data:
                  { properties: 
                    [ 
                      { property: 'title', value: _this.step2Form.title },
                      { property: 'firstname', value: _this.step2Form.firstName },
                      { property: 'middle_name', value: _this.step2Form.middleName },
                      { property: 'lastname', value: _this.step2Form.lastName },
                      { property: 'date_of_birth_transmit', value: _this.dateOfBirthStr },
                      { property: 'address', value: _this.step2Form.streetAddress },
                      { property: 'city', value: _this.step2Form.cityName },
                      { property: 'state', value: _this.step2Form.state },
                      { property: 'zip', value: _this.step2Form.zipCode },
                      { property: 'phone', value: _this.step2Form.cellPhone },
                      { property: 'ownership_percentage', value: _this.step2Form.businessOwnership },
                      { property: 'job_title_person_2', value: _this.step2Form.title2 },
                      { property: 'first_name_person_2', value: _this.step2Form.firstName2 },
                      { property: 'middle_name_person_2', value: _this.step2Form.middleName2 },
                      { property: 'last_name_person_2', value: _this.step2Form.lastName2 },
                      { property: 'date_of_birth_person_2_transmit', value: _this.dateOfBirth2Str },
                      { property: 'street_address_person_2', value: _this.step2Form.streetAddress2 },
                      { property: 'city_person_2', value: _this.step2Form.cityName2 },
                      { property: 'state_person_2_transmit', value: _this.step2Form.state2 },
                      { property: 'postal_code_person_2', value: _this.step2Form.zipCode2 },
                      { property: 'phone_person_2', value: _this.step2Form.cellPhone2 },
                      { property: 'ownership_person_2', value: _this.step2Form.businessOwnership2 }
                    ] 
                  }
                };
                const headers = {
                  "Content-Type": "application/json"
                };

                axios({
                  url: '/hsapi/update_contact',
                  method: 'post',
                  baseURL: 'https://api.amcredit.com/hubspot',
                  data: body,
                  headers: headers
                })
                .then(response => console.log(response))
                .catch(error => console.log(error));

                this.$router.push({
                  path: `/applyLoan/${this.$route.params.id}/upload`,
                  query: {
                    applyLoanId: this.$route.query.applyLoanId,
                    isEdit: this.$route.query.isEdit
                  }
                });
              } else {
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });
              }
            });
        } else {
          return false;
        }
      });
    },

    getEmailVerificationCode() {
      this.isLoadingCode = true;
      //alert(321)
      // REGISTRATIONä¸Žå¿˜è®°å¯†ç �çš„çŸ­ä¿¡éªŒè¯�å€’è®¡æ—¶ä¸�éœ€è¦�å…±ç”¨ï¼Œéœ€è¦�å°±å°†ç›¸å…³æ“�ä½œæ‰”åŽ»actionï¼ŒçŽ°åœ¨è¿™æ ·å°±ç›´æŽ¥è¯·æ±‚ï¼Œé™�ä½Žå¤�æ�‚åº¦
      // debugger;
      api
        .getSMSVerificationCodeForEmail({
          email: this.step2Form.email,
          tokenId: this.userInfo.token
        })
        .then(res => {
          this.isDisabledSendingVerifyCode = false;
          const resData = res.data;
          let countDownTime = 420;
          if (Number(resData.code) === 0) {
            this.countDown = setInterval(() => {
              this.isLoadingCode = false;
              this.isCounting = true;
              countDownTime -= 1;
              if (countDownTime !== 0) {
                this.SMSVerificationCodeBtn = {
                  disabled: true,
                  text: `After ${countDownTime} seconds`
                };
              } else {
                this.SMSVerificationCodeBtn = {
                  disabled: false,
                  text: "get code"
                };
                clearInterval(this.countDown);
                this.isCounting = false;
              }
            }, 1000);
          } else {
            this.isLoadingCode = false;
            this.setAlertMessage({
              show: true,
              content: resData.result
            });
          }
        })
        .catch(error => {
          if (error) {
            this.isLoadingCode = false;
          } else {
            this.isLoadingCode = false;
          }
        });
    },

    inputBlurFn(prop) {
      if (event.srcElement) {
        this.step2Form[prop] = event.srcElement.value;
      }
    }
  },
  //    beforeRouteLeave (to, from, next) {
  //      if (to.fullPath.indexOf('step1') !== -1) {
  //        this.goBack(next)
  //      } else if (to.fullPath.indexOf('step3') !== -1) {
  //        this.submitForm(next)
  //      }
  //    },
  mounted() {
    this.getMgxyDictionary();
    this.getPersonalInitData({
      token: this.userInfo.token,
      customerId: this.userInfo.crmCustomerId
    }).then(res => {
      console.log(res);
      if (Number(res.data.code) === 0) {
        const data = res.data.result;
        this.customerEmail = data.email;
      }
    });
  }
};
</script>

<style lang="scss">
.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}
</style>



// WEBPACK FOOTER //
// sbl3.vue?5e1473a0